<template>
  <div class="form-group card-selector">
    <label class="required-label">{{ this.inputTitle }}</label>
    <div class="dropdown">
      <input type="hidden" name="selected_binfinite_card" id="selected_binfinite_card" :value="isSelected ? selectedCard.card_no : ''">
      <input type="hidden" name="totalBpointRequire" id="totalBpointRequire">
      <button
        class="btn btn-secondary dropdown-toggle form-control"
        type="button"
        id="bcardDdMenuBtn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        aria-describedby="pointsAvailable"
      >
        {{ isSelected ? ((selectedCard.is_primary === 1 ? 'BCard&nbsp;' : '&nbsp;') + selectedCard.card_no) : 'Select BCard' }}
        <span
          class="balance-text"
          v-if="!isSelected"
        />
        <span class="balance-text" v-if="isSelected">
          Available
          BPoints
          <span
            class="pink"
          >{{ formatPoints(selectedCard.lms_BalancePoint) }}</span>
        </span>
      </button>
      <div class="dropdown-menu col-12" aria-labelledby="bcardDdMenuBtn">
        <!-- <a class="dropdown-item disabled">
          <small>Select card</small>
        </a> -->
        <a
          class="dropdown-item"
          v-for="card in this.parseObject"
          :key="card.id"
          :value="card"
          v-on:click="setSelectedCard(card, $event)"
        >
          {{ card.is_primary === 1 ? 'BCard' : '' }}&nbsp;{{ card.card_no }}
          <span
            class="balance-text no-caret"
          >
            Available
            BPoints
            <span class="pink">{{ formatPoints(card.lms_BalancePoint) }}</span>
          </span>
        </a>
      </div>
    </div>
    <p v-if="error_text != ''" class="balance-warning p-3 text-white mt-2" style="background-color: #f53d3d!important;"><span class="title">{{ error_text }}</span></p>
  </div>
</template>

<script>
export default {
  // Note: data-cards becomes camel case in props
  props: ["dataInputTitle", "dataCards"],
  data() {
    return {
      inputTitle: this.dataInputTitle,
      cards: this.dataCards,
      selectedCard: null,
      isSelected: false,
      error_text: "",
    };
  },
  methods: {
    setSelectedCard: function(card, e) {
      e.preventDefault();

      this.selectedCard = card;
      this.isSelected = this.selectedCard !== null;

      //   this.brandName = document.getElementById("partner_name").value;

      // For profile's set primary card dialog
      $("input#primary_card_no")
        // .parent()
        // .closest("input#primary_card_no")
        .val(this.selectedCard.card_no);

      // For trnafer points dialog
      if (this.inputTitle === "TRANSFER FROM") {
        $("input#source_card_no").val(this.selectedCard.card_no);
      } else if (this.inputTitle === "TRANSFER TO") {
        $("input#destination_card_no").val(this.selectedCard.card_no);
      }

      // For shoponline dialogs
      $("input#shop_card_no").val(this.selectedCard.card_no);
      $("input.cardID").val(this.selectedCard.card_no);
      // For payment summary
      $("input#payment_card_no").val(this.selectedCard.card_no);
      $("input#point").val(this.selectedCard.lms_BalancePoint);

      var totalBpointRequire = $('#totalBpointRequire').val();
      if(totalBpointRequire > 0){
          if(this.selectedCard.lms_BalancePoint - totalBpointRequire < 0){
              this.error_text = "Insufficient BPoints"
          }else{
              this.error_text ="";
          }
      }
    },
    formatPoints: function(value) {
      let val = (value / 1).toFixed(0);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    calcConvertablePoints: function() {
      return this.formatPoints(this.selectedCard.lms_BalancePoint / 100);
    },
    onClose: function() {
      this.selectedCard = null;
      this.isSelected = false;
    }
  },
  computed: {
    parseObject: function() {
      return JSON.parse(this.dataCards);
    }
    // },
    // mounted() {
    //   // vm.$forceUpdate();
    //   // console.log(this.parseObject);
  }
};
</script>
